<script setup>
import PlatformIcon from '../common/PlatformIcon.vue'
import PlayerBlockStats from '../player/PlayerBlockStats.vue'
import PlayerPosition from '../player/PlayerPosition.vue'

const { player, className, title } = defineProps({
    player: {
        type: Object,
        required: true,
    },
    className: {
        type: String,
        required: false,
        default: '',
    },
    title: {
        type: String,
        required: false,
    },
})

function getPositionShortTitle(player) {
    if (player.isCenter) return 'C'
    if (player.isRightWing) return 'RW'
    if (player.isLeftWing) return 'LW'
    if (player.isRightDef) return 'RD'
    if (player.isLeftDef) return 'LD'
    if (player.isDef) return 'D'
    if (player.position) return player.position.short_title
    if (player.lastGame.length) return player.lastGame[0].playerPosition.short_title
    return ''
}

function getPositionTitle(player) {
    if (player.isCenter) return 'Центр'
    if (player.isRightWing) return 'Правый нападающий'
    if (player.isLeftWing) return 'Левый нападающий'
    if (player.isRightDef) return 'Правый защитник'
    if (player.isLeftDef) return 'Левый защитник'
    if (player.isDef) return 'Защитник'
    if (player.position) return player.position.title
    if (player.lastGame.length) return player.lastGame[0].playerPosition.title
    return ''
}
</script>

<template>
<div :class="['team-player-cards__item', className]">
    <div v-if="title" class="best-card__position text-muted">{{ title }}</div>
    <div class="team-player-cards__item-number">{{ player ? player.number : '' }}</div>
    <a class="team-player-cards__item-link" :href="player ? player.link : ''">
        <div class="team-player-cards__item-image image-line-shadow">
            <span class="image-line-shadow__bg-shadow"></span>
            <img
                class="team-player-cards__item-image-profile image-line-shadow__image rounded-circle"
                :src="player ? player.avatar : ''"
                :alt="player ? player.tag.tag : ''"
            >
            <span class="team-player-cards__litera">
                <template v-if="player">
                    <img v-if="player.is_captain === 1" src="/images/positions/CAP.svg" alt="">
                    <img v-if="player.is_captain === 2" src="/images/positions/ASSIST.svg" alt="">
                </template>
            </span>
            <span class="line line-1"></span>
            <span class="line line-2"></span>
            <span class="line line-3"></span>
            <span class="line line-4"></span>
            <span class="line line-5"></span>
        </div>
        <div class="team-player-cards__bottom">
            <template v-if="player">
                <player-position :icon="getPositionShortTitle(player)" :alt="getPositionTitle(player)"/>
            </template>
        </div>
    </a>
    <div class="team-player-cards__item-info">
        <div class="team-player-cards__stats">
            <template v-if="player">
                <player-block-stats
                    v-for="stats in player.position_stats"
                    :key="stats.title"
                    :stats="stats"
                />
            </template>
        </div>
    </div>
    <div class="team-player-cards__nickname display20">
        <a :href="player ? player.link : ''" class="text-decoration-none">
            <platform-icon :platform="player.tag.platform_id"/>
            <span>{{ player ? player.tag.tag : '' }}</span>
        </a>
        <span
            v-if="player && player.country_id"
            :class="['fi', 'fi-' + player.country_id, 'fis', 'rounded-circle', 'ms-auto']"
        ></span>
    </div>
</div>

</template>
